import * as React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
import ReactDom from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import App from "./App";

import StateHelper from "store/StateHelper";
import { store } from "store/configureStore";

import analytics from "services/analytics";
import { unregister } from "./registerServiceWorker";

import theme from "./theme";
import { ThemeProvider } from "@mui/material/styles";

import "interceptors";

dayjs.extend(utc);

StateHelper.setStore(store);

analytics().initializeAll();

const container = document.getElementById("root");
const root = ReactDom.createRoot(container!);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <HelmetProvider>
          <PostHogProvider client={posthog}>
            <App />
          </PostHogProvider>
        </HelmetProvider>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>,
);

unregister();
